import { createFileRoute } from '@tanstack/react-router';
import { StatutoryStandardDetailPage } from './-components/StatutoryStandardDetailPage';
export const Route = createFileRoute('/_staff/legal-welfare-and-taxes-mock/_layout/statutory-standards/$standardId/')({
  component: StatutoryStandardDetailPage
});